// extracted by mini-css-extract-plugin
module.exports = {"typing":"owiiR","background":"_2Jcwa","content":"_3-VYW","wrapper":"_1rlpR","member":"_3Oa7V","separator":"_1mafn"};